import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="grid min-h-screen place-items-center bg-[#FAF9F5] p-6 text-center">
      <div>
        <p className="font-display text-8xl font-extrabold text-[#FF5500]">404</p>
        <h1 className="mt-4 font-display text-3xl font-extrabold">This page doesn't exist.</h1>
        <Link to="/" className="mt-6 inline-block rounded-full bg-[#0055FF] px-6 py-3 font-bold text-white">Go home</Link>
      </div>
    </div>
  );
}
